import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { getResponseMessage } from '../../../../../utils/utils';
import { useFormatMessage } from '../../../../../hooks';
import { getOrderById } from '../../../../../crud/orders.crud';
import { IOrderResponse } from '../../../../../interfaces/order';

export const useGetOrder = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState<IOrderResponse>();
  const fm = useFormatMessage();

  const fetchOrder = async (id: number) => {
    setLoading(true);
    getOrderById(id)
      .then(res => {
        setOrder(res.data.data);
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    fetchOrder,
    loading,
    order,
  };
};
